<template>
  <div class="flex flex-col">
    <span class="fs-14 text-black-light-5"> Total price: </span>
    <h4 class="fs-20 font-medium">
      <span>
        <currency-context>
          <template v-slot="{ convert }">
            <span v-text="convert(getTotalBooking)"></span>
          </template>
        </currency-context>
      </span>
    </h4>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyContext from "../../core/CurrencyContext";

export default {
  components: {
    CurrencyContext,
  },
  computed: {
    ...mapGetters(["getTotalBooking"]),
  },
  watch: {
    getTotalBooking: {
      immediate: true,
      handler(value) {
        const isMdsm = window.matchMedia("(max-width: 1200px)").matches;
        if (isMdsm) {
          if (!value) {
            document
              .querySelector(".resort-footer-nav")
              .classList.add("hidden");
            pushUpTrengoChat(false);
          } else {
            document
              .querySelector(".resort-footer-nav")
              .classList.remove("hidden");
            pushUpTrengoChat(true);
          }
        }
      },
    },
  },
};
</script>

<style scoped></style>
